import { Fragment, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";

import _ from "lodash";
import moment from "moment-timezone";
import Schemas from "schemas";
import styled from "styled-components";

import { DormitoryTab } from "./dormitories-page";

import { Control } from "components/ui-kit/control";
import { Breadcrumb, Button, Container, Frame, RowWrapper } from "components/ui-kit/styled-templates";

import { EVENT_TYPES_OPTIONS } from "constants/config";

import EventsApi from "api/events-api";
import UniversityApi from "api/university-api";

import useBodyBackground from "hooks/useBodyBackground";
import useDeviceParams from "hooks/useDeviceParams";
import useFormControl from "hooks/useFormControl";
import { useStorageListener } from "hooks/useStorage";

import { EForms, ERoles } from "types/enums";

type TProps = {
    mode: "create" | "edit";
};

/*
todo:
https://scr.sabir.pro/CvFflrHL
 */

const CreateEventBookingPage = (props: TProps) => {
    const { t, i18n } = useTranslation();


    const { mode = "create" } = props;

    useBodyBackground("white");
    let { requestId, eventId } = useParams();
    const navigate = useNavigate();
    const { isDesktop } = useDeviceParams();

    const uData = useStorageListener("user", {});

    const request = useStorageListener(`events-requests.${requestId}`, {});
    if (mode === "edit") {
        eventId = request.eventId;
    }
    const { details: event, universityId } = useStorageListener(`events.${eventId}`, {});
    const university = useStorageListener(`universities.${universityId}.details`, {});

    // const universities = useStorageListener(`universities`, {});
    // const { universityId, details: dormitory, rooms } = useStorageListener(`dormitories.${dormitoryId}`, {});

    const { data, setValue, setValues, clearForm, onSubmit } = useFormControl({
        name: EForms.editEventBooking,
        schema: Schemas[EForms.editEventBooking],
    });

    const handlers = {
        submit: async (details) => {
            if (mode === "create") {
                await EventsApi.createBooking({ eventId, details });
            } else {
                await EventsApi.updateBooking({ id: requestId, universityId, details });
            }
            navigate(-1);
        },
        cancel: () => {
            clearForm();
            navigate(-1);
        },
    };

    // @ts-ignore
    useEffect(UniversityApi.getAllUniversitiesData, []);
    // @ts-ignore
    useEffect(EventsApi.getEvents, []);
    // @ts-ignore
    useEffect(EventsApi.getMyBookings, []);

    // // @ts-ignore
    // useEffect(async () => {
    //     if (!dormitory && ((mode === "edit" && !!dormitoryId) || mode === "create")) {
    //         try {
    //             await DormitoriesApi.getDormitoryInfo(dormitoryId);
    //         } catch (error) {
    //             navigate(`/search`);
    //         }
    //     }
    // }, [dormitoryId, dormitory, mode]);
    // // @ts-ignore
    // useEffect(() => {
    //     if (!dormitory && ((mode === "edit" && !!dormitoryId) || mode === "create")) {
    //         RoomsApi.getDormitoryRooms(dormitoryId);
    //     }
    // }, [dormitoryId, dormitory, mode]);
    // // @ts-ignore
    // useEffect(UniversityApi.getAllUniversitiesData, []);
    // // @ts-ignore
    // useEffect(() => {
    //     if (mode === "edit" && !booking.dormitoryId) {
    //         BookingsApi.getMyBookings();
    //     }
    // }, [bookingId, mode]);

    useEffect(() => {
        if (mode === "edit" && !!request.eventId) {
            setValues(request.details);
        }
        if (mode == 'create'  && uData?.name != undefined && uData.name != ''){
            setValue('fullName', uData.name);
        }
    }, [JSON.stringify(request), uData]);

    return (
        <Container extra={`align-items: flex-start; h1 { margin-top: 0; };`}>
            <Breadcrumb.Wrapper>
                <Breadcrumb.Item to="/">{t("yfj3ag097un")}</Breadcrumb.Item>
                <Breadcrumb.Item to="/search">{t("idbu1bdg0jr")}</Breadcrumb.Item>
            </Breadcrumb.Wrapper>
            <DormitoryTab.Link color="blue" direction="left" onClick={() => navigate(-1)}>
                {t("sud5ydptrk")}
            </DormitoryTab.Link>
            <h1>{t("qwa6crijaj")}</h1>
            <RowWrapper extra={`gap: 15px; align-items: flex-start;`}>
                <Control.Form name={EForms.editEventBooking} onSubmit={onSubmit(handlers.submit)} extra={`margin-bottom: 10px;`}>
                    <Control.Row>
                        <Control.Input name="quantity" label={t("nafxxzsxlbb")} regex="[^0-9.]" extra="flex: 0.25;" isRequired />
                    </Control.Row>
                    <strong>{t("0wqanyeiv5w9")}</strong>

                    <Control.Row>
                        <Control.Radio
                            label={t("czmoetb8ii8")}
                            checked={_.get(data, `author.role`) === ERoles.University}
                            onChange={(e) => setValue(`author.role`, e.target.value === `on` ? ERoles.University : ERoles.Student)}
                        />
                        <Control.Radio
                            label={t("q5m2npd6rhj")}
                            checked={_.get(data, `author.role`) === ERoles.Student}
                            onChange={(e) => setValue(`author.role`, e.target.value === `on` ? ERoles.Student : ERoles.University)}
                        />
                    </Control.Row>

                    {/*<Control.Input*/}
                    {/*    name="author.name"*/}
                    {/*    label={data?.author?.role === ERoles.University ? `Наименование образовательной организации` : `ФИО`}*/}
                    {/*    placeholder={data?.author?.role === ERoles.University ? `Наименование образовательной организации` : `ФИО`}*/}
                    {/*    isRequired*/}
                    {/*/>*/}

                    <Control.Row>
                        <Control.Input name="fullName" label={t("o9cqm96n9di")} placeholder={t("obpugsmkpzf")} isRequired />
                    </Control.Row>
                    <Control.Row>
                        <Control.Input name="phone" label={t("pmu72yakkmf")} placeholder={t("vod1hvrk5pf")} isRequired />
                        <Control.Input name="email" label={t("v3kz17k3z6i")} placeholder={t("d6qh0dhpc1v")} isRequired />
                    </Control.Row>
                    <Control.Row extra="margin-top: 20px; margin-bottom: 10px;">
                        <Control.Switch
                            name="needsAccommodation"
                            label={i18n.language === "ru" ? "Требуется размещение на базе ООВО" : "Accommodation required"}
                            extra="justify-content: flex-start;"
                        />
                    </Control.Row>

                    {data?.needsAccommodation && (
                        <Control.Row>
                            <Control.Textarea
                                name="accommodationInfo"
                                label={i18n.language === "ru" ? "Дополнительная информация о размещении" : "Additional accommodation information"}
                                placeholder={i18n.language === "ru" ? "Укажите пожелания по размещению (количество мест, даты, особые требования)" : "Specify accommodation preferences (number of beds, dates, special requirements)"}
                            />
                        </Control.Row>
                    )}

                    {+_.get(data, "quantity", 0) > 0 && <strong>{t("qgioyzmvjn")}</strong>}
                    {new Array(+_.get(data, "quantity", 0)).fill(0).map((item, index) => (
                        <Fragment key={index}>
                            <h3>
                                {t("ylxgtv0qtcf")}
                                {index + 1}
                            </h3>
                            <Control.Row>
                                <Control.Input
                                    name={`participants.${index}.fullName`}
                                    label={t("4m3zhq1h7mt")}
                                    placeholder={t("hn3shh9y0h")}
                                    isRequired
                                />
                            </Control.Row>
                            <Control.Row>
                                <Control.Input name={`participants.${index}.phone`} label={t("4iatxrnkl5i")} placeholder={t("b7t9a1sehil")} />
                                <Control.Input name={`participants.${index}.email`} label={t("nw6yiutr22")} placeholder={t("5zih6jluz9")} />
                            </Control.Row>
                        </Fragment>
                    ))}
                    <Control.Row extra="gap: 10px; @media (max-width: 991px) { > * { width: 100%; }; };">
                        <Button variant="outlined" onClick={handlers.cancel}>
                            {t("5x3d7tjhsw4")}
                        </Button>
                        <Button type="submit">{mode === "create" ? t("u35efriwvv") : t("wwofp1mrb4")}</Button>
                    </Control.Row>
                </Control.Form>
                {isDesktop && <EventCard.Component event={event} university={university} />}
            </RowWrapper>
        </Container>
    );
};

const EventCard = {
    Component: (props) => {
        const { t, i18n } = useTranslation();
        let isRu = i18n.language === "ru";
        const { event, university } = props;

        console.log('event = ', event);

        return (
            <EventCard.Wrapper>
                <h3>{_.get(event, `name`, `-`)}</h3>
                <div className="type">{EVENT_TYPES_OPTIONS?.find?.((i) => i?.value === event?.type)?.label}</div>
                <div>{t("l1os2fngiop")}</div>
                <strong>{_.get(university, `name`, `-`)}</strong>
                <div>{t("odhi7m0sck")}</div>
                <strong>{event?.price} ₽</strong>
                <div>{t("xg5tbndwzlh")}</div>
                <strong>
                    {moment(event?.dates?.from).format(`DD.MM.YYYY`)} - {moment(event?.dates?.to).format(`DD.MM.YYYY`)}
                </strong>
                {(event?.from_time == undefined || event?.from_time == '') ? null :
                    <>
                        <div>{isRu ? 'Время проведения' : 'Start time'}</div>
                        <strong>
                            {event?.from_time}
                        </strong>
                    </>
                }
            </EventCard.Wrapper>
        );
    },
    Wrapper: styled(Frame)`
        align-items: flex-start;
        border: 1px solid ${({ theme }) => theme.halfblue};
        border-radius: 10px;
        padding: 20px;
        gap: 15px;
        box-sizing: border-box;

        font-size: 15px;
        line-height: 20px;

        .type {
            color: ${({ theme }) => theme.blue};
            font-weight: 400;
            font-size: 13px;
        }
    `,
};

export default CreateEventBookingPage;
